import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { FormsModule } from "@angular/forms";
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { HashLocationStrategy, LocationStrategy } from "@angular/common";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { Nl2BrPipeModule } from "nl2br-pipe";
import { DatePipe } from "@angular/common";

import { SafeHtmlPipes } from "./ifc/helper/safeHtmlPipes";
import { FilterListPipes } from "./ifc/helper/filterListPipes";
import { SearchListPipes } from "./ifc/helper/searchListPipes";
import { i18nPipe } from "./ifc/helper/i18n.pipes";
import { WebviewDateFormatPipe } from "./ifc/helper/webviewDetePipes";
import { OnlyNumber } from "./ifc/helper/onlynumber.directive";

import { CookieService } from "ngx-cookie-service";

import { ModalModule } from "ngx-bootstrap/modal";

import { HttpClientModule } from "@angular/common/http";

import { StateService } from "./ifc/services/state.service";
import { IFCAppServices } from "./ifc/services/ifcapp.service";

import { NotFoundComponent } from "./ifc/component/not-found/not-found.component";

import { DefaultLayoutComponent } from "./ifc/component/common/default-layout/default-layout.component";

import { SwiperModule } from "swiper/angular";
import { BaseService } from "./ifc/services/base.service";

import { RewardsListComponent } from "./ifc/icRewards/rewards-list/rewards-list.component";
import { RewardDetailComponent } from "./ifc/icRewards/reward-detail/reward-detail.component";

export const routes: Routes = [
  {
    path: "",
    redirectTo: "icRewards/rewards-list",
    pathMatch: "full",
  },
  {
    path: "icRewards",
    component: DefaultLayoutComponent,
    children: [
      { path: "rewards-list", component: RewardsListComponent },
      { path: "reward-detail", component: RewardDetailComponent },
    ],
  },
  { path: "icRewards/404", component: NotFoundComponent },

  { path: "**", redirectTo: "icRewards/404" },
];

@NgModule({
  declarations: [
    AppComponent,
    SafeHtmlPipes,
    FilterListPipes,
    SearchListPipes,
    i18nPipe,
    WebviewDateFormatPipe,
    OnlyNumber,
    NotFoundComponent,
    DefaultLayoutComponent,

    RewardsListComponent,
    RewardDetailComponent,
  ],
  imports: [
    FormsModule,
    Nl2BrPipeModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ModalModule.forRoot(),
    RouterModule.forRoot(routes, {
      relativeLinkResolution: "legacy",
      onSameUrlNavigation: "reload",
    }),
    SwiperModule,
  ],
  providers: [
    CookieService,
    i18nPipe,
    StateService,
    DatePipe,
    BaseService,
    IFCAppServices,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
